import { ColumnsType } from "antd/lib/table";
import { Installment } from "../types";
import { formatNumberToPtBr, formatPercent } from "../utils";
import { formatDate } from "../../../utils/formatDate";

export const columns: ColumnsType<Installment> = [
  {
    title: "Entrada (R$)",
    key: "valorEntrada",
    render: (row: Installment) =>
      row?.valorEntrada ? formatNumberToPtBr(row?.valorEntrada) : "",
  },
  {
    title: "Parcelas (R$)",
    key: "quantidadeParcelas",
    render: (row: Installment) =>
      `(${row.quantidadeParcelas && row.quantidadeParcelas - 1}x) ${
        row?.valorParcela ? formatNumberToPtBr(row?.valorParcela) : ""
      }`,
  },
  {
    title: "Total parcelado (R$)",
    key: "valorTotal",
    render: (row: Installment) =>
      row?.valorTotal ? formatNumberToPtBr(row?.valorTotal) : "",
  },
  {
    title: "IOF aplicado (R$)",
    key: "valorIof",
    render: (row: Installment) =>
      row?.valorIof ? formatNumberToPtBr(row?.valorIof) : "",
  },
  {
    title: "Taxa de Juros (%a.m.)",
    key: "taxaJuros",
    render: (row: Installment) =>
      row?.taxaJuros ? formatPercent(row?.taxaJuros, 3) : "",
  },
  {
    title: "CET (%a.a.)",
    key: "cet",
    render: (row: Installment) =>
      row?.cet ? formatNumberToPtBr(row?.cet) : "",
  },
  {
    title: "Data recomendada de ativação",
    key: "dataRecomendavelAtivacao",
    render: (row: Installment) => formatDate(row.dataRecomendavelAtivacao),
  },
];
